import { getConfigWithMetadata, hasAuthorization } from '@pkgs/api/utils/headers';
import { mapSearchListingsFiltersToSearchFilterRequest } from '@pkgs/api/utils/filters';
import { getErrorResult } from '@pkgs/api/utils/error';
import { type ApiConfig, type ApiResult, type BaseOptions } from '@pkgs/api/types';
import { type CreateSearchAlertResponse, type CreateSearchAlertV4Request } from '@generated/search-bff/models';
import { createSearchAlert as generatedCreateSearchAlert } from '@generated/search-bff/controllers/search-alert/search-alert';

/**
 * Create a search alert using the `/api/v4/searchalert/alert` endpoint.
 * Requires a valid JWT token in the `apiConfig`.
 * {@link https://search-docs-frontend-engelvoelkers.vercel.app/frontend/api/services/searchAlerts/createSearchAlert Search API Documentation}
 */
export async function createSearchAlert(
  payload: CreateSearchAlertV4Request,
  options: BaseOptions,
  apiConfig: ApiConfig,
): Promise<ApiResult<CreateSearchAlertResponse>> {
  try {
    const _apiConfig = getConfigWithMetadata(apiConfig, 'createSearchAlert');

    if (!hasAuthorization(_apiConfig)) {
      console.warn(
        'JWT token is required. Please provide a valid JWT token in the `apiConfig` via `jwtToken` or `headers.Authorization` or provide a `getToken` function in the `apiConfig`',
      );
    }

    const requestPayload: CreateSearchAlertV4Request = {
      ...payload,
      searchAlert: {
        ...payload.searchAlert,
        searchFilter: mapSearchListingsFiltersToSearchFilterRequest(payload.searchAlert.searchFilter, options),
      },
    };

    const response = await generatedCreateSearchAlert(requestPayload, _apiConfig);

    return {
      status: 'success',
      data: response,
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}
